import { encodeDelimitedArray, decodeDelimitedArray, QueryParamConfig } from 'use-query-params';

/** Uses a comma to delimit entries. e.g. ['a', 'b'] => qp?=a,b */
export const CommaArrayParam: QueryParamConfig<(string | null)[] | null | undefined, string[] | null | undefined> = {
  encode: (value) => encodeDelimitedArray(value, ','),
  decode: (value) => decodeDelimitedArray(value, ',')?.filter<string>((e): e is string => typeof e === 'string') || [],
};
